kv.controller('empowermentListCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
	vm.primaryKey = 'empowerment_id';
	vm.entity = 'empowerment';

	vm.count = {
		total: 0,
		showing: 0
	};

	vm.getInfinitScroll({
		params: {
			action: 'empowerment'
		},
		url: "empowerment",
	});

	return vm;
});

